import { SectionTitle } from '../../components/typography/Heading';
import styles from './reward-list.module.less';

export const RewardListSection = ({
    onProjectPage,
    singleView,
    title,
    showTitle = true,
    titleClass = '',
    description,
    showDescription = true,
    descriptionClass,
    children,
}) => {
    return (
        <div className={styles.rewardListSection}>
            {showTitle && (
                <SectionTitle className={[onProjectPage ? styles.projectText : '', titleClass].join(' ')}>
                    {title}
                </SectionTitle>
            )}
            {description && showDescription && (
                <div
                    className={[styles.description, onProjectPage ? styles.projectText : '', descriptionClass].join(
                        ' '
                    )}
                >
                    {description}
                </div>
            )}
            <div
                className={[
                    styles.rewardList,
                    singleView
                        ? onProjectPage
                            ? styles.showOnlyOnProject
                            : ''
                        : onProjectPage
                        ? styles.listOnProjectPage
                        : styles.listOnPaymentPage,
                ].join(' ')}
            >
                {children}
            </div>
        </div>
    );
};
